//shared/components/chat/MessageList.js
import React from "react";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Avatar,
} from "@mui/material";
import { format } from "date-fns";
import DoneAllIcon from "@mui/icons-material/DoneAll";

const MessageList = ({
  messages,
  loading,
  messagesEndRef,
  currentUserId,
  isTyping,
}) => {
  if (loading) {
    return (
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        overflow: "auto",
        p: 2,
        bgcolor: "grey.50",
        backgroundImage: "url(/chat-bg.png)",
        backgroundSize: "cover",
      }}
    >
      {messages
        .filter((msg) => msg.content || msg.message)
        .map((msg, index) => {
          const isMe = msg.from?._id === currentUserId || msg.role === "user";
          const showAvatar =
            !isMe &&
            (index === messages.length - 1 ||
              messages[index + 1]?.from?._id !== msg.from?._id);

          return (
            <Box
              key={msg._id}
              sx={{
                display: "flex",
                justifyContent: isMe ? "flex-end" : "flex-start",
                mb: 1,
                alignItems: "flex-end",
                gap: 1,
              }}
            >
              {!isMe && showAvatar && (
                <Avatar
                  src={
                    msg.from?._id === "llama-assistant"
                      ? "/images/dentinhoCutNoBg.png"
                      : msg.from?.avatar
                      ? `${process.env.REACT_APP_BACKEND_LINK}/${msg.from.avatar}`
                      : null
                  }
                  sx={{
                    width: 28,
                    height: 28,
                    bgcolor:
                      msg.from?._id === "llama-assistant" ? "#ccc" : undefined,
                    padding: "3px",
                    "& img": {
                      objectFit: "contain",
                      imageRendering: "auto",
                    },
                  }}
                >
                  {msg.from?._id === "llama-assistant"
                    ? "IA"
                    : msg.from?.name?.[0]}
                </Avatar>
              )}
              {!isMe && !showAvatar && <Box sx={{ width: 28 }} />}

              <Paper
                sx={{
                  p: 1.5,
                  maxWidth: "70%",
                  bgcolor: isMe ? "primary.main" : "white",
                  color: isMe ? "white" : "text.primary",
                  borderRadius: 2,
                  borderBottomRightRadius: isMe ? 0 : 2,
                  borderBottomLeftRadius: isMe ? 2 : 0,
                }}
                elevation={1}
              >
                {!isMe && (
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      fontWeight: 600,
                      mb: 0.5,
                      color:
                        msg.from?._id === "llama-assistant"
                          ? "secondary.main"
                          : "primary.main",
                    }}
                  >
                    {msg.from?._id === "llama-assistant"
                      ? "Dentinho"
                      : msg.from?.name || ""}
                  </Typography>
                )}
                <Typography
                  variant="body2"
                  sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}
                >
                  {msg.message || msg.content}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mt: 0.5,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ opacity: 0.7, fontSize: "0.7rem" }}
                  >
                    {format(new Date(msg.createdAt || msg.timestamp), "HH:mm")}
                  </Typography>

                  {isMe && (
                    <DoneAllIcon
                      sx={{
                        fontSize: 16,
                        opacity: 0.7,
                        color: msg.read ? "#4fc3f7" : "inherit",
                      }}
                    />
                  )}
                </Box>
              </Paper>
            </Box>
          );
        })}

      {isTyping && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 1,
          }}
        >
          <Avatar
            sx={{
              width: 28,
              height: 28,
              bgcolor: "secondary.main",
            }}
          >
            IA
          </Avatar>
          <Paper
            sx={{
              p: 1.5,
              bgcolor: "white",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
            elevation={1}
          >
            <Box
              sx={{
                display: "flex",
                gap: 0.5,
                "& > span": {
                  width: 8,
                  height: 8,
                  bgcolor: "grey.400",
                  borderRadius: "50%",
                  animation: "bounce 1.4s infinite ease-in-out",
                },
                "& > span:nth-of-type(1)": { animationDelay: "-0.32s" },
                "& > span:nth-of-type(2)": { animationDelay: "-0.16s" },
                "@keyframes bounce": {
                  "0%, 80%, 100%": { transform: "scale(0)" },
                  "40%": { transform: "scale(1)" },
                },
              }}
            >
              <span />
              <span />
              <span />
            </Box>
          </Paper>
        </Box>
      )}
      <div ref={messagesEndRef} />
    </Box>
  );
};

export default MessageList;
